import React, { useContext } from "react";

import "./About.css";
import { ThemeContext } from "../../contexts/ThemeContext";
import { aboutData } from "../../data/aboutData";
import { FaInstagram } from "react-icons/fa";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { AiOutlineSend, AiOutlineCheckCircle } from "react-icons/ai";
function About() {
  const useStyles = makeStyles((t) => ({
    socialIcon: {
      width: "25px",
      height: "25px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "21px",
      backgroundColor: theme.primary,
      color: theme.secondary,
      transition: "250ms ease-in-out",
      "&:hover": {
        transform: "scale(1.1)",
        color: theme.secondary,
        backgroundColor: theme.tertiary,
      },
    },
    resumeBtn: {
      color: theme.primary,
      borderRadius: "30px",
      textTransform: "inherit",
      textDecoration: "none",
      width: "150px",
      fontSize: "1rem",
      fontWeight: "500",
      height: "50px",
      fontFamily: "var(--primaryFont)",
      border: `3px solid ${theme.primary}`,
      transition: "100ms ease-out",
      "&:hover": {
        backgroundColor: theme.tertiary,
        color: theme.secondary,
        border: `3px solid ${theme.tertiary}`,
      },
      [t.breakpoints.down("sm")]: {
        width: "180px",
      },
    },
    submitBtn: {
      backgroundColor: theme.primary,
      marginStart:'5px',
      marginEnd:'5px',
      width:'150px',
      color: theme.secondary,
      transition: "250ms ease-in-out",
      "&:hover": {
        transform: "scale(1.08)",
        color: theme.secondary,
        backgroundColor: theme.tertiary,
      },
    },
  }));
  const { theme } = useContext(ThemeContext);
  const classes = useStyles();

  return (
    <div
      className="about"
      id="about"
      style={{ backgroundColor: theme.secondary }}
    >
      <div className="line-styling">
        <div
          className="style-circle"
          style={{ backgroundColor: theme.primary }}
        ></div>
        <div
          className="style-circle"
          style={{ backgroundColor: theme.primary }}
        ></div>
        <div
          className="style-line"
          style={{ backgroundColor: theme.primary }}
        ></div>
      </div>
      <div className="about-body">
        <div className="about-description">
          <h2 style={{ color: theme.primary }}>{aboutData.title}</h2>
          <p style={{ color: theme.tertiary80 }}>
            {aboutData.description1}
            <br />
            <br />
            {aboutData.description2}
          </p>

          {/* ==== */}

          {/* <div className="contacts--container" style={{marginLeft:'5px',marginRight:'5px', paddingLeft:'0px',paddingRight:"0px",paddingTop:"20px"}}> */}
            {/* <div className="contacts-body"> */}
              {/* <div className="contacts-form" style={{display:'flex',justifyContent:"space-between"}}>
                <div className="submit-btn">
                  <button type="submit" className={classes.submitBtn}>
                    <p>Dinz English</p>
                    <div className="submit-icon">
                      <FaInstagram className={classes.socialIcon}></FaInstagram>
                    </div>
                  </button>
                </div>

                <div className="submit-btn">
                  <button type="submit" className={classes.submitBtn}>
                    <p>Dinz Translator</p>
                    <div className="submit-icon">
                      <FaInstagram className={classes.socialIcon}> </FaInstagram>
                    </div>
                  </button>
                </div>
              </div> */}
            {/* </div> */}
          {/* </div> */}

          {/* ==== */}
        </div>
        <div className="about-img">
          <img
            src={aboutData.image === 1 ? theme.aboutimg1 : theme.aboutimg2}
            alt=""
          />
        </div>
      </div>
    </div>
  );
}

export default About;
